import React, {PureComponent} from 'react';
import {NavLink} from 'react-router-dom';
import {searchWork} from 'utils/search';
import {INDEX_PAGE_SIZE} from 'constants';
import Pager from 'ui-components/Pager';
import KeyShortcut from './KeyShortcut';


export default class Index extends PureComponent{
	
	static defaultProps = {
		pageSize: INDEX_PAGE_SIZE,
		page: 1,
		measurePerf: false,
		useCachedSpace: true
	}

	constructor(props){
		super(props);
	}

	navigateOut = () => {
		const {navigateTo} = this.props;
		if (this.lastFocus){
			const {id, firstWork} = this.lastFocus;
			navigateTo(`/gallery/${id || firstWork}`);
		}
	}

	componentDidMount(){
		window.scrollTo(0, 0);
	}

	onClick = (w) => {
		let id = w.firstWork || w.id;
		this.props.navigateTo(`/gallery/${id}`);
	}

	onFocus = (w) => {
		this.lastFocus = w;
	}

	render(){
		let {
			works,
			pageSize,
			page,
			artists,
			searchText,
			scrollingElementId
		} = this.props;

		return (
			<Pager
				pageSize={pageSize}
				items={artists.concat(works)}
				searchFunc={searchWork}
				scrollingElementId={scrollingElementId}
			>{({items}) => 
				<Results
					items={items}
					onClick={this.onClick}
					onFocus={this.onFocus}
				/>
			}</Pager>
		);
	}
}


export class Results extends PureComponent{
	render(){
		let {
			items,
			onClick,
			onFocus
		} = this.props;
		return (
			<div className="index">
			<KeyShortcut k="Enter" action={this.navigateOut} />
			{
				items.map((w, idx) =>
					<IndexLink
						key={w.id || w.name}
						tabIndex={idx + 2}
						piece={w}
						onClick={onClick}
						onFocus={onFocus.bind(null, w)}
					/>
				)
			}</div>
		);
	}
}


export class IndexLink extends PureComponent{
	render(){
		let {
			piece,
			onClick,
			...attrs
		} = this.props;
		return (
			<NavLink
				to={piece.id ? `/gallery/${piece.id}` : `/gallery/${piece.firstWork}`}
				className="item"
				{...attrs}
			>{
				piece.name
				? (<div>
					<span
						className="artist-link"
						dangerouslySetInnerHTML={{
							__html: piece.name
						}}
					/>
					<a
						href={piece.url}
						className="artist-site"
						target="_blank"
						rel="noopener"
					>↗</a>
					</div>
				) : (
					<div>
						<span className="page">{piece.page}</span>
						<span className="artist">{piece.artist}</span>
						<span className="work">{piece.title}</span>
					</div>
				)
			}</NavLink>
		);	
	}
}